var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    staticClass: "ml-auto",
    attrs: {
      processing: _vm.processing,
      buttonText: _vm.buttonText,
      variant: "linkButton",
      size: "no",
    },
    on: { click: _vm.handleDeleteRating },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }